import React from 'react'
import {Button, DateTimePickerField, SelectField} from '../../Components/Inputs'
import {GridCell, gridConstants} from "../../Components/Grid";
import {REPORT_TYPE_DESCRIPTIONS, REPORT_TYPES, REPORT_TYPES_LIST} from './reportsConstants';
import {SearchableSingleSelectField} from "../../Components/Inputs/SearchableSingleSelectField";
import {createListFromArrayOfObjects} from "../../Utilities/Types/listUtilities";

interface ReportsFormViewProps {
    districts: Record<string, any>[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleExportReport: (...args: any[]) => void;
    reportForm: Record<string, any>;
}

export const ReportsFormView = ({
                                    districts,
                                    handleExportReport,
                                    reportForm
                                }: ReportsFormViewProps) => {

    const isReportForCompletedOrders = reportForm.reportType.value === REPORT_TYPES.OwnOrdersCompleted;

    return <>
        <GridCell>
            <SelectField
                {...reportForm.reportType}
                options={REPORT_TYPES_LIST}
                includeDefaultOption
                defaultOption={"Select Report Type"}
                helpText={REPORT_TYPE_DESCRIPTIONS[reportForm.reportType.value]}
            />
            {
                isReportForCompletedOrders &&
                <SearchableSingleSelectField
                    {...reportForm.districtId}
                    medium_columns={gridConstants.column.SIX}
                    defaultOption={"All"}
                    includeDefaultOption
                    label={'District'}
                    options={createListFromArrayOfObjects(districts, "id", "districtName")}
                />
            }
            {
                <>
                    <DateTimePickerField
                        {...reportForm.startDate}
                        medium_columns={gridConstants.column.SIX}
                        label={isReportForCompletedOrders ? `Date Order Created` : `Start Date`}/>

                    <DateTimePickerField
                        {...reportForm.endDate}
                        medium_columns={gridConstants.column.SIX}
                        label={isReportForCompletedOrders ? `Date Order Fulfilled` : `End Date`}/>
                </>
            }
            <Button
                isCollapsed
                isPrimary
                name='exportReport'
                onClick={handleExportReport}
                label={"Export Report"}
            />
        </GridCell>
    </>
}

